import { getStylesObjFromCss } from "../../../../../utils/common/styling";

export const styles = getStylesObjFromCss({
  styles: {
    root: {
      background: "white",
      position: "relative",
      zIndex: 1,
      borderRadius: "20px",
      boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
    },

    accordionRoot: {
      backgroundColor: "transparent !important",
    },

    header: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
      margin: "8px 0",
      padding: "0",
      minHeight: "48px",
    },

    label: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      cursor: "pointer",
      color: "#272522",
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: "normal",
      whiteSpace: "pre-wrap",
    },

    labelWithoutActions: {
      justifyContent: "space-between",
      width: "100%",
    },

    expandCta: {
      padding: "0px !important",
      transition: "transform .2s ease-in-out !important",
      "& svg": {
        color: "#272522",
      },
    },
    expanded: {
      transform: "rotate(90deg)",
    },

    details: {
      padding: "0 !important",
      backgroundColor: "transparent",
    },

    divider: {
      background: "#E9E9E9",
      height: "1px",
      border: "none",
      margin: "0 16px",
    },

    addCta: {
      marginTop: "10px !important",
      marginBottom: "12px !important",
    },

    draggable: {
      background: "#F7F5FF !important",
    },

    actions: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      "& button": {
        padding: 0,
        "& svg": {
          fontSize: "21.33px",
        },
      },
      "& svg": {
        color: "#948AD9",
      },
    },
    dragCta: {
      cursor: "grab",
    },
  },
  componentName: "Collection",
});
